import { render, staticRenderFns } from "./RsaGestioneOspitiListComponent.vue?vue&type=template&id=e50e9af6"
import script from "./RsaGestioneOspitiListComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestioneOspitiListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports